module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_pets-7d31ab9bd27c0161e0b3d9349ac1754c.jpg";